export const PAYMENT_INFORMATION_LIST_REQUEST = 'PAYMENT_INFORMATION_LIST_REQUEST';
export const PAYMENT_INFORMATION_LIST_SUCCESS = 'PAYMENT_INFORMATION_LIST_SUCCESS';
export const PAYMENT_INFORMATION_LIST_FAIL = 'PAYMENT_INFORMATION_LIST_FAIL';
